export default {
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/errors/errors.js